import React from 'react';
import { Box } from 'grommet';
import styled from 'styled-components';
import { StyledSpan } from 'granite-admin/core/components/Animations/SkeletonAnimation';
const NameBox = styled(StyledSpan)`
  width: 120px;
`;
const DescBox = styled(StyledSpan)`
  width: calc(100% - 5px);
  height: 25px;
`;
const TasksSkeletonLoader = () => {
  return /*#__PURE__*/React.createElement(Box, {
    gap: "medium",
    flex: true,
    overflow: {
      vertical: 'auto'
    },
    pad: "small"
  }, [...Array(4).keys()].map((i, ind) => /*#__PURE__*/React.createElement(Box, {
    key: ind + 'tasks-cards',
    pad: "medium",
    elevation: "small",
    round: "xsmall",
    gap: "medium",
    flex: {
      shrink: 0
    }
  }, /*#__PURE__*/React.createElement(NameBox, null), /*#__PURE__*/React.createElement(DescBox, null), /*#__PURE__*/React.createElement(NameBox, null))));
};
export default TasksSkeletonLoader;